import { store } from "../../app";
import { TenantFeaturesModel, TenantModel } from "../../data/entities";
import { TenantRepo, TenantODataRepo } from "../../data/repo";
import { BaseEntityService } from "../BaseEntityService"

export class TenantService extends BaseEntityService<TenantModel, TenantRepo, TenantODataRepo> {
  constructor(){
    super(new TenantRepo(), new TenantODataRepo());
  }

  static readonly getTenantId = () => store.getState().authentication.tenantId ?? -1;

  async getFeaturesAsync(id: number): Promise<TenantFeaturesModel | null> {
    return await this.repo.getFeaturesAsync(id);
  }

  async saveFeaturesAsync(id: number, features: TenantFeaturesModel): Promise<TenantFeaturesModel | null> {
    return await this.repo.saveFeaturesAsync(id, features);
  }

}

export default TenantService;
